const NextArrowIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 3.2C0 2.0799 0 1.51984 0.217987 1.09202C0.409734 0.715695 0.715695 0.409734 1.09202 0.217987C1.51984 0 2.0799 0 3.2 0H20.8C21.9201 0 22.4802 0 22.908 0.217987C23.2843 0.409734 23.5903 0.715695 23.782 1.09202C24 1.51984 24 2.0799 24 3.2V20.8C24 21.9201 24 22.4802 23.782 22.908C23.5903 23.2843 23.2843 23.5903 22.908 23.782C22.4802 24 21.9201 24 20.8 24H3.2C2.0799 24 1.51984 24 1.09202 23.782C0.715695 23.5903 0.409734 23.2843 0.217987 22.908C0 22.4802 0 21.9201 0 20.8V3.2Z"
      fill="#DBE0E4"
      className="icon-bg"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1528 7.64652L12.7992 7.29297L12.0921 8.00008L12.4457 8.35363L15.5915 11.4995H7.19922H6.69922V12.4995H7.19922H15.5927L12.4457 15.6465L12.0921 16.0001L12.7992 16.7072L13.1528 16.3536L17.1528 12.3536C17.348 12.1584 17.348 11.8418 17.1528 11.6465L13.1528 7.64652Z"
      fill="#22202F"
    />
  </svg>
);

export { NextArrowIcon };
